import { render, staticRenderFns } from "./frmdokumentumfeltoltes.vue?vue&type=template&id=5e833b9a&"
import script from "./frmdokumentumfeltoltes.vue?vue&type=script&lang=js&"
export * from "./frmdokumentumfeltoltes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports